export default "__VITE_ASSET__DV6eUMLh__"